/* eslint-disable camelcase */
import Api from 'services/api';
import { BiddingData } from 'store/modules/bidding_store/types';
import ApiFiles from '../api_files';

export const getDownloadBiddings = async (
  file_extension: string,
  document_type: string,
  bidding_ids: Array<number>,
  per_page: number,
  companyId?: number,
  biddings_manageds?: boolean,
  biddings_finished?: boolean,
  biddings_progress?: boolean,
  tasks_ids?: Array<number>,
  biddings_tasks?: boolean,
  favorite: boolean = false,
) => {
  const response = await ApiFiles.get(
    `/biddings.${file_extension}?favorite=${favorite}` +
      `${biddings_manageds ? '&biddings_manageds=true' : ''}` +
      `${biddings_finished ? '&biddings_finished=true' : ''}` +
      `${biddings_progress ? `&biddings_progress=true&tasks_ids=${tasks_ids?.join(',')}` : ''}` +
      `${biddings_tasks ? `&biddings_tasks=true&tasks_ids=${tasks_ids?.join(',')}` : ''}` +
      `${file_extension === 'docx' ? '&docx=true' : ''}` +
      `${file_extension === 'xlsx' ? '&xlsx=true' : ''}` +
      `&per_page=${per_page}&biddings_ids=${bidding_ids.join(',')}&companyId=${companyId}`,
  );

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${document_type}_${Date.now()}.${file_extension}`);
  document.body.appendChild(link);
  link.click();
};

export const getDownloadImminance = async (
  file_extension: string,
  document_type: string,
  bidding_ids: Array<number>,
  per_page: number,
  favorite: boolean = false,
) => {
  const response = await ApiFiles.get(
    `/bidding_desert/imminence.${file_extension}?favorite=${favorite}&${
      file_extension === 'docx' ? 'docx=true' : ''
    }${
      file_extension === 'xlsx' ? 'xlsx=true' : ''
    }&per_page=${per_page}&biddings_ids=${bidding_ids.join(',')}`,
  );

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${document_type}_${Date.now()}.${file_extension}`);
  document.body.appendChild(link);
  link.click();
};

export const getDownloadContracts = async (
  file_extension: string,
  document_type: string,
  bidding_ids: Array<number>,
  per_page: number,
  favorite: boolean = false,
) => {
  const response = await ApiFiles.get(
    `/contracts/contratos.${file_extension}?favorite=${favorite}&${
      file_extension === 'docx' ? 'docx=true' : ''
    }${
      file_extension === 'xlsx' ? 'xlsx=true' : ''
    }&per_page=${per_page}&biddings_ids=${bidding_ids.join(',')}`,
  );

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${document_type}_${Date.now()}.${file_extension}`);
  document.body.appendChild(link);
  link.click();
};

export const getDownloadAtas = async (
  file_extension: string,
  document_type: string,
  bidding_ids: Array<number>,
  per_page: number,
  favorite: boolean = false,
) => {
  const response = await ApiFiles.get(
    `/ata_de_registro_preco.${file_extension}?favorite=${favorite}&${
      file_extension === 'docx' ? 'docx=true' : ''
    }${
      file_extension === 'xlsx' ? 'xlsx=true' : ''
    }&per_page=${per_page}&biddings_ids=${bidding_ids.join(',')}`,
  );
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${document_type}_${Date.now()}.${file_extension}`);
  document.body.appendChild(link);
  link.click();
};

export const getBidding = async (
  bidding_id: string,
  setBidding: React.Dispatch<React.SetStateAction<BiddingData | null>>,
) => {
  const response = await Api.get(`/biddings/${bidding_id}.json`);

  if (response?.status === 200) setBidding(response.data);
};
